export default __webpack_public_path__ + "static/media/100006.25a62d52.jpg";